import React, { useEffect, useState } from 'react';
import { Routes, Route} from 'react-router-dom';
import Home from './Routes/Home';
import About from './Routes/About';
import Projects from './Routes/Projects';
import ScrollToTop from './Components/ScrollToTop';
import StupidDesigns from './Routes/Projects/StupidDesigns';
import AIProjects from './Routes/Projects/AIProjects';
import PersonalProjects from './Routes/Projects/PersonalProjects';
import ProjectDetail from './Routes/ProjectDetail';
import Navbar from './Components/Navbar';
import { Helmet } from 'react-helmet-async';
import Chatbot from './Routes/Projects/AIProjects/Chatbot';

function App() {

    const titles = [
      "Indra's Portfolio",
      "Please Hire Me",
  ];

  const [titleIndex, setTitleIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTitleIndex((prev) => (prev + 1) % titles.length);
    }, 2000); // Change title every 2 seconds
    return () => clearInterval(interval);
  });

  return (
    <div className="bg-gray-900 text-white min-h-screen">
      <Helmet>
        <title>{titles[titleIndex]}</title>
        <meta name="description" content="Welcome to Indra's portfolio. Explore my projects and learn more about me." />
        <link rel="icon" href="/favicon.ico" />
      </Helmet>
      <Navbar />
      <main className="container mx-auto px-4">

        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />

          <Route path="/projects/StupidDesigns" element={<StupidDesigns />} />
          <Route path="/projects/AIProjects" element={<AIProjects />} />
          <Route path="/projects/PersonalProjects" element={<PersonalProjects />} />
          
          <Route path="/projects/:sectionName/:projectName" element={<ProjectDetail />} />
        </Routes>
      </main>
      <Chatbot />
    </div>
  );
}

export default App;